{
  "hero": {
    "eyebrow": "Student-led engineering · Vancouver, Canada",
    "title": "AquaWorks — water-quality monitoring.",
    "subtitle": "AquaWorks is a student-led engineering project developed by students at the University of British Columbia. This site is located on UBC's Vancouver campus.",
    "ctaPrimary": "Join the team",
    "ctaSecondary": "Explore the project",
    "legend": "Radar-assisted · remotely supervised"
  },
  "status": {
    "items": [
      { "value": "Phase 1", "label": "Build window", "note": "September–December 2026" },
      { "value": "5", "label": "Core indicators", "note": "Temperature, pH, turbidity, conductivity, DO" },
      { "value": "4", "label": "Student teams", "note": "Software, Electrical, Mechanical, Business" },
      { "value": "Jan 2027", "label": "Handoff report", "note": "Archive for future student teams" }
    ]
  },
  "identity": {
    "title": "What is AquaWorks?",
    "body": "AquaWorks — also known as AquaWork — is a student-led engineering project developed by students at the University of British Columbia. This homepage is the index for aquawork.ca, located on UBC's Vancouver campus, for the team building a radar-assisted water-quality monitoring robot."
  },
  "pillars": {
    "title": "What Phase 1 delivers",
    "lead": "A practical prototype for controlled still-water testing—not a brochure, and not a replacement for laboratory analysis.",
    "panels": {
      "platform": {
        "kicker": "01 / Platform",
        "title": "Modular floating robot",
        "body": "Buoyancy, propulsion, waterproof electronics, radar-assisted distance awareness, and safe shore retrieval."
      },
      "sense": {
        "kicker": "02 / Sense",
        "title": "Five water-quality indicators",
        "body": "Interchangeable sensors with calibration notes, timestamps, and spatial references on every record."
      },
      "viz": {
        "kicker": "03 / Visualize",
        "title": "Routes, trends, space",
        "body": "CSV-compatible logs become route maps, time-series plots, and at least one spatial water-quality visualization."
      }
    }
  },
  "roadmap": {
    "title": "A phased path beyond still water",
    "lead": "Phase 1 builds the foundation. Later phases aim for shoreline-adjacent and area-based monitoring—only with permission, safety review, and further funding.",
    "cta": "See the full roadmap"
  },
  "context": {
    "title": "Why mobile monitoring matters on the Vancouver campus",
    "body": "Stormwater quality and rainfall-linked change are long-term campus priorities. Fixed stations and previous SEEDS plans matter—AquaWorks adds repeatable, location-linked observations along a defined route.",
    "cta": "Read the science"
  },
  "sdgs": {
    "title": "Sustainable Development Goals we align with",
    "items": {
      "education": "Quality Education",
      "water": "Clean Water and Sanitation",
      "innovation": "Industry, Innovation and Infrastructure",
      "cities": "Sustainable Cities and Communities",
      "consumption": "Responsible Consumption and Production",
      "climate": "Climate Action",
      "lifeBelowWater": "Life Below Water",
      "partnerships": "Partnerships for the Goals"
    }
  },
  "cta": {
    "title": "Help build a reusable campus monitoring platform.",
    "body": "Students across engineering and business are shaping AquaWorks. Join a sub-team, advise on methods, or follow the build log.",
    "button": "Get in touch"
  }
}
